import { render, staticRenderFns } from "./Remember.vue?vue&type=template&id=40727d8e&"
import script from "./Remember.vue?vue&type=script&lang=js&"
export * from "./Remember.vue?vue&type=script&lang=js&"
import style0 from "./Remember.vue?vue&type=style&index=0&id=40727d8e&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports